import { set } from './__util__';
import { field } from './field';
export function fieldN() {
  var obj = field.apply(void 0, arguments);
  set(obj, "type", "nominal");
  return obj;
}